import React from 'react';
import PropTypes from 'prop-types';
import { StickyContainer } from 'react-sticky';

const PreAuthApp = ({ children }) => (
  <div>
    <StickyContainer>{children}</StickyContainer>
  </div>
);

PreAuthApp.propTypes = {
  children: PropTypes.shape({}),
};

export default PreAuthApp;



// WEBPACK FOOTER //
// ./src/pages/preauth/PreAuthApp.jsx